import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './DadosDoEstabelecimentoPage.css';
import TituloComponent from '../../components/Titulo/TituloComponent';
import { buscarDadosEstabelecimento, salvarEdicaoDadosEstabelecimento } from '../../services/api';

const DadosDoEstabelecimento = () => {
  const navigate = useNavigate();
  const userData = JSON.parse(sessionStorage.getItem('userData'));

  const [isAuthorized, setIsAuthorized] = useState(true);
  const [loading, setLoading] = useState(true); // Estado de carregamento
  const [formData, setFormData] = useState({
    nome: '',
    telefone_fixo: '',
    telefone_celular: '',
    endereco: '',
    uf: '',
    cidade: '',
    descricao: '',
    imagem: null,
    atualizarLocalizacao: false,
    latitude: sessionStorage.getItem('latitude') || '',
    longitude: sessionStorage.getItem('longitude') || '',
  });


  useEffect(() => {

    console.log('*** Entrou no useEffect ***');
    console.log('latitude da sessão: ' + sessionStorage.getItem('latitude'));
    console.log('longitude da sessão: ' + sessionStorage.getItem('longitude'));

    console.log('userData: ');
    console.log(userData);

    if (!userData || userData.dadosPerfil?.nome !== 'BAR GERENTE' || userData.statusUsuario !== 'logado') {
      setIsAuthorized(false);
      navigate('/area-restrita');
    } else {
      // Chama a função para obter a localização atual
      // obterLocalizacao();

      fetchDadosEstabelecimento();
      setLoading(false); // Localização obtida, pode atualizar a UI
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      imagem: e.target.files[0],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formDataToSend = new FormData();

      /**
       * Verificando se o checkbox 'atualizarLocalizacao' está marcado
       * se estiver vamos fazer o append da latitude e da longitude
       */
      if (formData.atualizarLocalizacao) {
        const latitude = sessionStorage.getItem('latitude');
        const longitude = sessionStorage.getItem('longitude');

        if (latitude && longitude) {
          formDataToSend.append('latitude', latitude);
          formDataToSend.append('longitude', longitude);
        } else {
          console.log('Erro: Latitude ou Longitude não estão definidos');
        }
      }

      /**
       * Adicionando outros campos ao FormData
       * não vamos adicionar novamente latitude nem longitude, pois já foram adicionados.
       */
      Object.keys(formData).forEach((key) => {
        if (formData[key] !== null && formData[key] !== '' && key !== 'latitude' && key !== 'longitude') {
          formDataToSend.append(key, formData[key]);
          console.log('append = ' + key + ' - ' + formData[key]);
        }
      });

      const response = await salvarEdicaoDadosEstabelecimento(userData, formDataToSend);
      if (response?.success) {
        alert('Dados atualizados com sucesso!');
        fetchDadosEstabelecimento();
        navigate('/area-restrita');
      } else {
        alert(response?.message || 'Erro ao atualizar os dados. Tente novamente.');
      }
    } catch (error) {
      console.error('Erro ao salvar os dados:', error);
      alert('Erro ao salvar os dados. Verifique e tente novamente.');
    }
  };

  const fetchDadosEstabelecimento = async () => {
    try {
      const dados = await buscarDadosEstabelecimento(userData);
      if (dados?.dadosEstabelecimento) {
        setFormData((prevData) => ({
          ...prevData,
          ...dados.dadosEstabelecimento,
        }));
      }
    } catch (error) {
      console.error('Erro ao buscar dados do estabelecimento:', error);
    }
  };

  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/area-restrita');
  };

  if (!isAuthorized) {
    return <div>Redirecionando...</div>;
  }

  if (loading) {
    return <div>Carregando localização...</div>; // Exibe uma mensagem enquanto a localização não estiver pronta
  }

  return (
    <div className="dados-estabelecimento-container">
      <TituloComponent />
      <h1 className="sub-titulo">Dados do Estabelecimento</h1>


      <div className="dados-estabelecimento-box">


        <p className="texto-welcome">Você está em { userData.dadosEstabelecimento.nome } </p>

        {/* Exibe o nome do perfil do usuário */}
        <p className="texto-welcome">Latitude atual: {formData.latitude}</p>
        <p className="texto-welcome">Longitude atual: {formData.longitude}</p>


        <button className="dados-estabelecimento-btn" onClick={handleLogout}>Logout</button>
      </div>

      {/* Formulário principal sem div extra */}
      <form onSubmit={handleSubmit} className="dados-estabelecimento-form">
        {/* Quadro de Geolocalização separado */}
        <div className="dados-estabelecimento-geolocalizacao">
          <fieldset>
            <legend>Nova Geolocalização</legend>
            <div className="form-group">
              <input
                type="checkbox"
                id="atualizarLocalizacao"
                name="atualizarLocalizacao"
                checked={formData.atualizarLocalizacao}
                onChange={handleInputChange}
              />
              <label htmlFor="atualizarLocalizacao"> Desejo atualizar a minha nova localização</label>
            </div>

            <div className="form-group">
              <label htmlFor="latitude">Nova Latitude</label>
              <input 
                type="text" id="latitude" name="latitude" className="form-control" 
                value={sessionStorage.getItem('latitude')} onChange={handleInputChange} />
            </div>

            <div className="form-group">
              <label htmlFor="longitude">Nova Longitude</label>
              <input 
                type="text" id="longitude" name="longitude" className="form-control" 
                value={sessionStorage.getItem('longitude')} onChange={handleInputChange} required />
            </div>
          </fieldset>
        </div>

        <div className="form-group">
          <label htmlFor="nome">Nome</label>
          <input type="text" id="nome" name="nome" className="form-control" 
            value={formData.nome} onChange={handleInputChange} required />
        </div>

        <div className="form-group">
          <label htmlFor="telefone_fixo">Telefone Fixo</label>
          <input type="text" id="telefone_fixo" name="telefone_fixo" className="form-control" value={formData.telefone_fixo} onChange={handleInputChange} required />
        </div>

        <div className="form-group">
          <label htmlFor="telefone_celular">Telefone Celular</label>
          <input type="text" id="telefone_celular" name="telefone_celular" className="form-control" value={formData.telefone_celular} onChange={handleInputChange} required />
        </div>

        <div className="form-group">
          <label htmlFor="endereco">Endereço</label>
          <input type="text" id="endereco" name="endereco" className="form-control" value={formData.endereco} onChange={handleInputChange} required />
        </div>

        <div className="form-group">
          <label htmlFor="uf">UF</label>
          <input type="text" id="uf" name="uf" className="form-control" value={formData.uf} onChange={handleInputChange} required />
        </div>

        <div className="form-group">
          <label htmlFor="cidade">Cidade</label>
          <input type="text" id="cidade" name="cidade" className="form-control" value={formData.cidade} onChange={handleInputChange} required />
        </div>

        <div className="form-group">
          <label htmlFor="descricao">Descrição</label>
          <textarea id="descricao" name="descricao" className="form-control" value={formData.descricao} onChange={handleInputChange} required />
        </div>

        <div className="form-group">
          <label htmlFor="imagem">Imagem</label>
          <input type="file" id="imagem" name="imagem" className="form-control" onChange={handleFileChange} />
        </div>

        <button type="submit" className="dados-estabelecimento-btn">Alterar Dados</button>
      </form>
    </div>
  );
};

export default DadosDoEstabelecimento;

